import { Location, locationDefault } from "./location";
import { User } from "./user";
export interface PmpConfigForLocations extends Location {
  pmp_config?: PmpConfig;
  config_status?: string;
}

export interface RetailSettings {
  id: number | null;
  status: 1 | 0 | null;
}

export interface PmpConfig {
  id: number | null;
  status: number;
  host_name: string;
  user_name: string;
  password: string;
  directory: string;
  port: number | null;
  pmp_driver: string;
  pmp_auto_submission_interval: string;
  location_id: number | null;
  account_id: number | null;
  created_at: string;
  updated_at: string;
  location: Location;
}

export const pmpConfigDefault: PmpConfig = {
  id: null,
  status: 0,
  host_name: "",
  user_name: "",
  password: "",
  directory: "",
  port: null,
  pmp_driver: "",
  pmp_auto_submission_interval: "",
  location_id: null,
  account_id: null,
  created_at: "",
  updated_at: "",
  location: locationDefault
};

export interface PmpHistoryLogs {
  id: number | null;
  modified_by_user_id: number | null;
  modified_field: string;
  modified_from: string;
  modified_to: string;
  pmp_ftp_config_id: number | null;
  created_at: string;
  updated_at: string;
  user: User;
}
